import * as React from "react"


export default function productCategoryColumn() {
    return {
        name: 'pageProductCategory', label: 'Product Category',
        options: {
            filter: false,
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRender: value => value
        }
    }
}